<div class="wrap">
  <div class="pools">
    <HeaderBlock isPoolPage="true"/>
    <div class="page" :class="{ 'connected': isActiveWallet }">
      <div class="title-block container">
        <div class="title-block-container">
          <div class="title">
            List of pools on the BNB Chain Network
          </div>
          <div v-if="!isActiveWallet"
               class="connect-btn connect-btn-blue"
               @click="onConnectClick">
            Connect wallet
          </div>
          <div class="total-amount-block">
            <div class="total-amount-stacked">
              <p class="total-amount-title">Your total amount staked</p>
              <p class="total-amount-value">${{ totalStackedUsd }}</p>
            </div>
          </div>
        </div>
        <div class="account-details-button"
             v-if="isActiveWallet"
             @click="accountDetails">
          Account details
        </div>
      </div>
      <div v-if="filteredEthPools.length > 0 || filteredBscPools.length > 0 || filteredPolygonPools.length > 0"
           class="blockchains">
        <div v-if="filteredEthPools.length > 0" class="blockchain container">
          <div class="description">
            <img src="/static/images/pools/ethereum.svg" alt="Ethereum Network"/>
            <span>List of pools on the Ethereum Network</span>
          </div>
          <pool v-for="pool in filteredEthPools" :pool="pool" :key="pool.name"/>
        </div>
        <div class="blockchain container">
          <pool v-for="pool in filteredBscPools" :pool="pool" :key="pool.name"/>
        </div>
        <div class="blockchain container">
          <div v-if="filteredPolygonPools.length > 0" class="description">
            <img src="/static/images/logo/polygon.svg" alt="Polygon Network"/>
            <span>List of pools on the Polygon Network</span>
          </div>
          <pool v-for="pool in filteredPolygonPools" :pool="pool" :key="pool.name"/>
        </div>
      </div>
      <div v-else class="empty">
        <img src="/static/images/pools/empty.svg" alt="Empty"/>
        <div>You have no pools with already staked amount</div>
      </div>
    </div>
  </div>
  <footer-block class="footer"/>
</div>
